import "../css/style.scss";
import "./animations.js";
import "./accordion.js";

import HeroSlider from "./modules/HeroSlider";

// Instantiate a new object using our modules/classes
const heroSlider = new HeroSlider();


const menuOpenIcon = document.querySelector('.wp-block-navigation__responsive-container-open svg');

if (menuOpenIcon){
	menuOpenIcon.innerHTML = "";

	var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
	circle.setAttribute('cx','10');
	circle.setAttribute('cy','10');
	circle.setAttribute('r','9');
	circle.setAttribute('stroke','#fff');
	circle.setAttribute('stroke-width','1.5');
	circle.setAttribute('fill','transparent');
	const menuLabel = document.createTextNode("Menu");
	menuOpenIcon.parentElement.appendChild(menuLabel);
	menuOpenIcon.appendChild(circle);
}

const menuCloseIcon = document.querySelector('.wp-block-navigation__responsive-container-close svg');

if (menuCloseIcon){
	menuCloseIcon.innerHTML = "";

	var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
	circle.setAttribute('cx','10');
	circle.setAttribute('cy','10');
	circle.setAttribute('r','9');
	circle.setAttribute('stroke','transparent');
	circle.setAttribute('stroke-width','1.5');
	circle.setAttribute('fill','currentColor');
	const menuLabel = document.createTextNode("Menu");
	menuCloseIcon.parentElement.appendChild(menuLabel);
	menuCloseIcon.appendChild(circle);
}


// move language selector


//window.addEventListener("DOMContentLoaded",function(e){

	const langSelector = document.querySelector('.mk-lang-selector');
	const menuContainer = document.querySelector('nav.wp-block-navigation[aria-label="Main menu"] .wp-block-navigation__responsive-container-content');

	if (langSelector && menuContainer) {
		menuContainer.appendChild(langSelector);

		const langSelectorBtn = langSelector.querySelector('button');

		langSelectorBtn.addEventListener('click',function(){
			langSelector.classList.toggle('open');
		});
	}

//});



// fix safari overflow bug, trigger a window.resize event after opening first level menu items

const firstLevelMenuItems = document.querySelectorAll('.wp-block-navigation__container .wp-block-navigation-item.has-child.open-on-click');

if (firstLevelMenuItems){
	firstLevelMenuItems.forEach(function(el){
		el.addEventListener('click', function(e){
			// console.log('resize!');
			setTimeout(()=>{
				window.dispatchEvent(new Event('resize'));
			},20);
		});
	});
}


const collapseNextCtas = document.querySelectorAll(".cta-collapse-next");

if (collapseNextCtas){

	collapseNextCtas.forEach(cta => {
		
		cta.addEventListener("click",(e)=>{
			e.preventDefault();
			e.target.classList.toggle('collapsed');
			// console.log(e.target);
		});
	});
}


// content navigation

const contentNavs = document.querySelectorAll('.wp-block-post-content > .wp-block-navigation');

// console.log(groups);

if (contentNavs){
	
	
	contentNavs.forEach(contentNav => {
		
		// check if element is first child page of parent
		const isParent = document.body.classList.contains('page-parent');
		
		// console.log(isParent);
		
		if (isParent){
			
			const navItems = contentNav.querySelectorAll('.wp-block-navigation-link');
			
			if (navItems){
				// Highlight first menu item
				navItems[0].classList.add('current-menu-item');
			}
			
		}
		
		
		// add a button for mobile
		const mobileToggle = document.createElement('button');
		mobileToggle.classList = "dgs-nav-menu-mobile-toggle";
		contentNav.appendChild(mobileToggle);

		mobileToggle.addEventListener("click", (e) => {
			e.preventDefault();
			// mobileToggle.classList.toggle('active');
			contentNav.classList.toggle('open');
		});
	});
}


// Tabs group

const tabsGroups = document.querySelectorAll(".dgs-tabs-group");

if (tabsGroups){

	tabsGroups.forEach(tabGroup => {

		const nav = tabGroup.querySelector('.mk-tabs-navigation');
		const groups = tabGroup.querySelectorAll(':scope > .wp-block-group');

		// console.log(groups);

		if (nav && groups){
			
			if (!nav.classList.contains('icons-menu')){

				// add a button for mobile
				const mobileToggle = document.createElement('button');
				mobileToggle.classList = "dgs-tabs-group-mobile-toggle";
				nav.appendChild(mobileToggle);
	
				mobileToggle.addEventListener("click", (e) => {
					e.preventDefault();
					// mobileToggle.classList.toggle('active');
					nav.classList.toggle('open');
				});
			}


			
			const navItems = nav.querySelectorAll('.wp-block-navigation-link');

			if (groups){
				// show first group
				groups[0].classList.add('active');
			}

			if (navItems){
				// Highlight first menu item
				navItems[0].classList.add('current-menu-item');

				navItems.forEach((navItem,idx) => {

					navItem.addEventListener("click", (e) => {
						e.preventDefault();
						
						// clear all groups
						for (const group of groups){
							group.classList.remove('active');
						}

						for (const menuItem of navItems){
							menuItem.classList.remove('current-menu-item');
						}

						// show selected group
						if (groups[idx]){
							groups[idx].classList.add('active');
						}

						// highlight selected menu item
						navItems[idx].classList.add('current-menu-item');

						// close mobile menu
						nav.classList.remove('open');

					});
				});
			}
		}

	});
}


// CHECK IF FORM FIELDS ARE FILLED IN

const cf7textFields = document.querySelectorAll('.wpcf7-form-control-wrap input');

if (cf7textFields){
	cf7textFields.forEach((theField)=>{
		theField.onchange = (e) => {
			// console.log(e.target.value);
			if (e.target.value){
				if (e.target.value.trim()){
					theField.classList.add('filled');
				}
			}
		}
	});
}


// MAP LINKS

const mapLinks = document.querySelectorAll('.map-link a');
if (mapLinks) {
	mapLinks.forEach(mapLink => {
		mapLink.addEventListener("click", e => {
			e.preventDefault();
			const prevAddress = mapLink.parentElement.previousElementSibling.innerHTML;
			if (prevAddress) {
				const mapAddr = prevAddress.replace(/(\<br\>)/gm, " ");
				window.open('https://maps.google.com/?q='+encodeURIComponent(mapAddr), '_blank');
			}
		});
	});
}




// FULLSCREEN TOGGLE

function toggleFullscreen(elem){

	if (elem.requestFullscreen) {
		elem.requestFullscreen();
	} else if (elem.msRequestFullscreen) {
		elem.msRequestFullscreen();
	} else if (elem.mozRequestFullScreen) {
		elem.mozRequestFullScreen();
	} else if (elem.webkitRequestFullscreen) {
		elem.webkitRequestFullscreen();
	}
	
}

const fsElements = document.querySelectorAll('.fullscreen-element');

if (fsElements){

	fsElements.forEach((fsElement)=>{
	
		const fsBtn = fsElement.querySelector('.cta-go-fullscreen');
		const fsContent = fsElement.querySelector('.fullscreen-content');

		if (fsBtn && fsContent){
			fsBtn.addEventListener("click", (e) => {
				e.preventDefault();
				// console.log(fsContent);
				toggleFullscreen(fsContent);
			});
		}
	});
}


// MK accordions

const mkAccordionItems = document.querySelectorAll('.mk-accordion-item');

if (mkAccordionItems){

	mkAccordionItems.forEach((mkA)=> {
		
		const mkAbtn = mkA.querySelector('button');

		mkAbtn.addEventListener('click',(e)=>{
			e.preventDefault();
			mkA.classList.toggle('open');
		});
	});

}

// Social share

const socialShareContent = document.querySelectorAll(".social-share-content");

if (socialShareContent){
	
	socialShareContent.forEach(function(el){
		
		let btn = el.querySelector('.social-menu-toggle');
		
		//console.log((Date.now() % 1000) / 1000);
		
		btn.addEventListener('click', function(e){
			el.classList.toggle('open');
		});
	});
}



// scroll up button

const scrollUpBtns = document.querySelectorAll('button.mk-scroll-up');

if (scrollUpBtns){
	scrollUpBtns.forEach((scrollUpBtn)=>{
		scrollUpBtn.addEventListener('click', (e)=>{
			e.preventDefault();
			window.scrollTo(0, 0);
		});
	});
}




var prevScroll = 0;

window.addEventListener("DOMContentLoaded",function(e){

	window.addEventListener("scroll", function(){
		var curScroll = window.pageYOffset || document.documentElement.scrollTop;
		
		if (curScroll > 40){
			document.body.classList.add('sticky-header');
			document.querySelector('.wp-site-blocks > header.wp-block-template-part').classList.add('is-sticky');
		} else {
			document.body.classList.remove('sticky-header');
			document.querySelector('.wp-site-blocks > header.wp-block-template-part').classList.remove('is-sticky');
		}

		prevScroll = curScroll <= 0 ? 0 : curScroll;

	}, false);

});
